import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useEmpresasTabelas() {
    const [empresasTabelas, setEmpresasTabelas] = useState([]);

    useEffect(() => {
        axios.get('http://provin.ind.br:5000/empresasTabelas')
            .then(response => {
                setEmpresasTabelas(response.data);
            })
            .catch(err => console.error('Erro ao buscar empresas:', err));
    }, []);

    return empresasTabelas; // ← retorna direto o array
}